import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReserveInStoreLineComponent } from '@features/reserve-in-store/reserve-in-store-line/reserve-in-store-line.component';
import { ReserveInStoreFormComponent } from '@features/reserve-in-store/reserve-in-store-form/reserve-in-store-form.component';
import { ReserveInStoreUserDialogComponent } from '@features/reserve-in-store/reserve-in-store-user-dialog/reserve-in-store-user-dialog.component';
import { ReserveInStorePickupStoreComponent } from '@features/reserve-in-store/reserve-in-store-pickup-store/reserve-in-store-pickup-store.component';

import { CanChangeStoreInReservationPipe } from '../reserve-in-store/reserve-in-store-pipes/can-change-store-in-reservation.pipe';
import { HasOutOfStockLinesPipe } from '../reserve-in-store/reserve-in-store-pipes/has-out-of-stock-lines.pipe';
import { ShowReservationPipe } from '../reserve-in-store/reserve-in-store-pipes/show-reservation.pipe';
import { FindStoreFromId } from '../reserve-in-store/reserve-in-store-pipes/find-store-from-id.pipe';

import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { DialogModule } from '@features/dialog/dialog.module';
import { StoresOverviewModule } from '@features/stores-overview/stores-overview.module';
import { ProductMiniModule } from '@features/product-mini/product-mini.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        FormElementsModule,
        DialogModule,
        StoresOverviewModule,
        ProductMiniModule,
        ReserveInStoreLineComponent,
        ReserveInStoreFormComponent,
        ReserveInStoreUserDialogComponent,
        ReserveInStorePickupStoreComponent,
        CanChangeStoreInReservationPipe,
        HasOutOfStockLinesPipe,
        ShowReservationPipe,
        FindStoreFromId
    ],
    exports: [
        ReserveInStoreLineComponent,
        ReserveInStorePickupStoreComponent,
        CanChangeStoreInReservationPipe,
        HasOutOfStockLinesPipe,
        ShowReservationPipe,
        FindStoreFromId
    ]
})
export class ReserveInStoreModule {}
